// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fWoP","question":"styles_question__2B2kR","inputVisibleButton":"styles_inputVisibleButton__2Cqaf","note":"styles_note__W4Gcs"};